import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import { SITE_NAME } from '../config/site';

export default function ContactPage() {
  const title = `Contact ${SITE_NAME}`;
  const description = `Reach the ${SITE_NAME} team for product questions, partnerships, or support. Call or WhatsApp us.`;

  const SUPPORT_MOBILE_DISPLAY = '9959167972';
  const SUPPORT_MOBILE_E164 = '+919959167972';
  const WHATSAPP_LINK = `https://wa.me/919959167972`;

  return (
    <>
      <SeoMeta title={title} description={description} path="/contact" ogType="website" />

      <main className="static-page contact-page">
        <header className="static-page-hero container">
          <h1>Contact us</h1>
          <p className="static-page-lead">
            Questions about early access, the product, or support? Reach us directly.
          </p>
        </header>

        <section className="container contact-section" aria-labelledby="contact-direct-heading">
          <h2 id="contact-direct-heading" className="screen-reader-label">
            Contact options
          </h2>

          <div className="card contact-direct-card">
            <p className="contact-direct-title">Call or WhatsApp</p>
            <p className="contact-direct-sub">We respond as fast as we can during beta.</p>

            <div className="contact-direct-actions">
              <a className="btn btn-primary" href={`tel:${SUPPORT_MOBILE_E164}`}>
                Call {SUPPORT_MOBILE_DISPLAY}
              </a>
              <a className="btn btn-secondary" href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                WhatsApp us
              </a>
            </div>
          </div>
        </section>

        <footer className="static-page-foot container">
          <p>
            <Link to="/about">About</Link>
            {' · '}
            <Link to="/">Home</Link>
          </p>
        </footer>
      </main>
    </>
  );
}
